import React, { useState } from 'react'
import { SearchMd } from '../../../icons/SearchMd';
import configs, { translations } from '../../../contentConfig';
import { useLocation } from 'react-router';
import SearchInfo from './SearchInfo';
import RecentSearch from '../../Trip/RecentSearch';
import { set } from 'lodash';
import { trackSearch } from '../../../utils/FunctionsForGa';


const searchPlaceHolder =  translations?.searchInputPlaceHolder || "Search for restaurants, events, attractions etc."
const showSearchInfo = configs?.['header']?.["searchInput"]?.showSearchInfo || false

const SearchInput = ({q,inputRef,fetchData,setQ}) => {
       const [isFocused, setIsFocused] = useState(false);
         const location = useLocation();

       const clearInput = () => {
        if (inputRef.current) {
          inputRef.current.value = "";
          inputRef.current.blur(); 
        }
        // const newSearchParams = new URLSearchParams(location.search);
        // newSearchParams.set('q', "");
        // window.history.replaceState(window.history.state, '', `?${newSearchParams.toString()}`);
        setQ("")
      };
  return (
<>

<div
       className="flex items-center gap-4 px-4 py-0 relative self-stretch w-full flex-[0_0_auto] header-search">
       <div
          style={{
           transition: 'width 0.25s',
           width: isFocused || q ? '100%' : '100%',
         }}
       className="flex items-center gap-2 px-3 py-4 relative self-stretch w-full flex-[0_0_auto] bg-[#f6f6f6] rounded-lg border border-solid border-[#dddddd] search-bar-box">
         <SearchMd
         className="!relative !w-5 !h-5 search-icon" />
             <input
           type="search"
           placeholder={searchPlaceHolder}
           className="bg-transparent outline-none w-full font-secondary font-medium text-[#888888] text-sm tracking-[0] leading-[16.1px] whitespace-nowrap search-placeholder"
           ref={inputRef}
           onKeyDown={(e) => {
             if (e.key === 'Enter') {
              const query = inputRef.current?.value || "";
              trackSearch({query: query})
               fetchData(e);
               setIsFocused(false);
               inputRef.current.blur();
             }
           }}
           style={{
             border: "none",
      background: "transparent",
      borderRadius: 0,
      padding: 0,
           }}
           onFocus={(e)=>{
             e.stopPropagation()
             setIsFocused(true)
           }}
         />
         {

(isFocused || q) &&  <>
<svg
onClick={(e)=>{
e.stopPropagation()
const prevq = inputRef.current.value
clearInput()
if(prevq)
fetchData()
setIsFocused(false)
}}
className="search-inp-cross cursor-pointer"
xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M18 6L6 18M6 6L18 18" stroke="#F6F3EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</>
}
       </div>
       {(isFocused) && <RecentSearch setQ={setQ} fetchData={fetchData} setIsFocused={setIsFocused} inputRef={inputRef} />}
     
     </div>
    {
        showSearchInfo && <SearchInfo isVisible={isFocused} />
    }
</>
  )
}

export default SearchInput
